module.exports = __webpack_public_path__ + "img/accounting-statement.d53d2b41.svg";